import * as graphql from '@treams/treams-network';

import { FeatureRatingSection } from '../../../feature-ratings/FeatureRatingSection';

export const EvaluationSubmissionAIInsightsFeedback = ({
	submissionID,
}: {
	submissionID: string;
}) => (
	<FeatureRatingSection
		featureName={graphql.FeatureName.ConversationAiInsights}
		targetID={submissionID}
		targetType={graphql.FeatureRatingTargetType.EvaluationSubmission}
		i18nPrefix="feature.ratings.ai.insights"
	/>
);
